export default __webpack_public_path__ + "9f82a0bf5a540470abaf447c7cb7587c.png";